import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Configurator from './pages/Configurator';
import MarketingStrategy from './pages/MarketingStrategy';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import ScrollToTop from './common/ScrollToTop';

/**
 * App Component
 */
function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/konfigurator" element={<Configurator />} />
            <Route path="/leistungen" element={<Services />} />
            <Route path="/ablauf" element={<Home />} />
            <Route path="/ueber-uns" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/marketing-strategy" element={<MarketingStrategy />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;